import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Constants from 'style/constants';

import MonitoringIcon from '../monitoring-icon';
import { MonitoringType } from '../monitoring-type';

import './monitoring-alert.scss';

type Props = {
  type: MonitoringType;
  lastChangedOn?: Date;
  message?: string;
  color: string;
  text: string;
};

const MonitoringAlert = ({ type, lastChangedOn, message, color, text }: Readonly<Props>): React.JSX.Element => (
  <div className="monitoring-alert-container" data-testid={`monitoring-alert-${type}`}>
    {lastChangedOn && (
      <Typography variant="body2" sx={{ color: Constants.Colors.onSurface }}>
        {moment(lastChangedOn).format('DD-MM-YYYY HH:mm').toString()}
      </Typography>
    )}
    <Box
      className="status-container"
      sx={{
        border: `3px solid ${color}`,
      }}
    >
      <div className="status-row">
        <MonitoringIcon type={type} withTooltip={false} visible={true} size={24} />
        <Typography variant="body1" sx={{ color: Constants.Colors.onSurface }}>
          {text}
        </Typography>
      </div>
      {message && (
        <Typography variant="subtitle1" className="text-padding" sx={{ color: Constants.Colors.onSurface }}>
          {message}
        </Typography>
      )}
    </Box>
  </div>
);

export default MonitoringAlert;
